'use strict';

const Slide = require('./slide');
const Modal = require('../modal');
const lang = require('../lang');
const template = require('../templates/control-question-slide.hbs');

module.exports = class extends Slide {
  constructor(context = {}) {
    super(template, context);
    _idletimer = _mainidletimer;
    this.domEvents = {
      'click a[data-nav-next]': '_validateAnswer',
      //'mousemove': '_resetIdleTimer',
      'keydown': '_resetIdleTimer',
      'click': '_resetIdleTimer'
    };

    this.on('beforeEnter', () => {
      this._shuffleAnswers(context.questionData);
      //todo: Clean this up =)
      let correctAnswer = $('#' + context.questionData.id);
      correctAnswer.removeAttr('checked');
      correctAnswer.prop("checked", false);
    });

    this.on('afterLeave', () => {
      //todo: Clean this up =)
      let correctAnswer = $('#' + context.questionData.id);
      correctAnswer.removeAttr('checked');
      correctAnswer.prop("checked", false);
    });
    this.on('afterEnter', this._stopIdleTimer);
    this.on('afterEnter', this._countdown);
  }

  reset() {

  }

  _shuffleAnswers() {
    let cards = $("[question|='" + this._context.questionData.id + "']");
    for (let i = 0; i < cards.length; i++) {
      let target = Math.floor(Math.random() * cards.length - 1) + 1;
      let target2 = Math.floor(Math.random() * cards.length - 1) + 1;
      cards.eq(target).before(cards.eq(target2));
    }
  }

  _validateAnswer(e) {
    if ($('#' + this._context.questionData.id).is(':checked'))
      return true;
    new Modal({
      titleText: lang.get('control_question_modal_title'),
      bodyText: lang.get('control_question_modal_body'),
      submitBtnText: lang.get('control_question_modal_button')
    });
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  _resetIdleTimer() {
    $('.idle-timer-container').hide();
    _idletimer = _mainidletimer;
  }

  _countdown() {
    _idletimer = _mainidletimer;
    $('.idle-timer-container').hide();
    const $domTimer = this.$el.find('#idle-timer');
    _idleintervalHandler = setInterval(() => {
      _idletimer -= 1;
      if (_idletimer <= 30) {
        $('.idle-timer-container').show();
        $domTimer.html(_idletimer);
      }
      if (_idletimer === 0) {
        this._slideshow._clearForm();
        $('#modal').modal('hide');
        clearInterval(_idleintervalHandler);
        _idletimer = _mainidletimer;
        $('.idle-timer-container').hide();
        window.location.hash = '/';
      }
    }, 1000);
  }

  _stopIdleTimer() {
    if (_idleintervalHandler !== undefined) {
      clearInterval(_idleintervalHandler);
    }
  }

};
